export default __webpack_public_path__ + "images/bunnings-logo.2ed2550600d2666e155b75e7ad7d0626.svg";